module.exports = __webpack_public_path__ + "img/box7-10-10.32d646db.png";